import { configureStore } from "@reduxjs/toolkit";
import GymCategoryReducer from "../redux/slice/GymCategory";
import FeaturedGymReducer from "./slice/FeaturedGym";
import TrendingGymReducer from "./slice/TrendingGym";
import BlogListReducer from "./slice/BlogList";
import ProductReducer from "./slice/Product";
import AuthReducer from "./slice/Auth";
import FaqListReducer from "./slice/FaqList";
import CartReducer from "./slice/CartSlice";

export const store = configureStore({
  reducer: {
    GymCategory: GymCategoryReducer,
    FeaturedGym: FeaturedGymReducer,
    TrendingGym: TrendingGymReducer,
    BlogList: BlogListReducer,
    Product: ProductReducer,
    Auth: AuthReducer,
    FaqList: FaqListReducer,
    Cart: CartReducer,
  },
});

export default store;
